<div *ngIf='!field.hidden' id="control_{{field.name}}" class="form-group">
    <div [ngSwitch]="field.type_normalized"
         [draggable]="field.draggable"
	     (dragover)="dragActions('enter', $event)"
	     (dragleave)="dragActions('leave', $event)"
	     (dragend)="dragActions('end', $event)"
         [ngClass]="{dragged: draggedOver}">
         
        <label class="control-label width-100" for="control_field_{{field.name}}">
        	{{field.title ? field.title : field.name}}{{field.required ? "*" : ""}}
            <i *ngIf="field.draggable" title="{{LOCALIZATION.dragDropFieldTooltip}}" class="right fas fa-ellipsis-v drag circleme"></i>
        </label>
        <div class="controls">
			<div class="btn-group" *ngSwitchCase="'RADIO'" [attr.id]="'control_field_' + field.name" [attr.title]="field.tooltip">
			  <label 
			    *ngFor="let radio of field.filteredOptions" 
			    class="btn btn-primary" 
			    [ngClass]="{ 'active': field.content === radio.value }"
			    (click)="updateFn(field)" 
			    (keyup.enter)="field.content = radio.value">
				    <input 
				    	type="radio" 
				    	[(ngModel)]="field.content" 
				    	[name]="field.name"
				    	[value]="radio.value"
				     	hidden />
				    	{{ radio.name }}
			  </label>
			</div>
            
            <p *ngSwitchCase="'DATE'" class="input-group">
				<input type="text" 
				       class="form-control flatpickr" 
				       [ngClass]="{'invalid-field' : !isValid}"
				       [attr.id]="'control_field_' + field.name"
				       [name]="'daterange_' + field.name"
				       [attr.data-field]="field.name"
				       [(ngModel)]="field.content"
				       placeholder='{{field.placeholder}}' 
				       [attr.title]="field.tooltip" 
				       (blur)="blur($event)"
				       (focus)="openDatePicker(field.name)"
				       (keyup.enter)="dateValidation($event)" />                           
                <span class="input-group-btn">
                    <button type="button" 
                    	class="btn btn-default" 
                    	(click)="openDatePicker(field.name)" 
                    	title="{{LOCALIZATION.openCalendar}}" 
                    	[attr.aria-label]="LOCALIZATION.openCalendar">
                    		<i class="fas fa-calendar-alt" aria-hidden="true"></i>
                    </button>
                </span>
            </p>
            <p *ngSwitchCase="'DATE_RANGE'" class="input-group">
				<input type="text" 
				       class="form-control flatpickr" 
				       [ngClass]="{'invalid-field' : !isValid}"
				       [attr.id]="'control_field_' + field.name"
				       [name]="'daterange_' + field.name"
				       [attr.data-field]="field.name"
				       [(ngModel)]="field.content"
				       placeholder='{{field.placeholder}}' 
				       [attr.title]="field.tooltip" 
				       (blur)="blur($event)"
				       (focus)="openDatePicker(field.name)"
				       (keyup.enter)="dateValidation($event)" />                           
                <span class="input-group-btn">
                    <button type="button" 
                    	class="btn btn-default" 
                    	(click)="openDatePicker(field.name)" 
                    	title="{{LOCALIZATION.openCalendar}}" 
                    	[attr.aria-label]="LOCALIZATION.openCalendar">
                    		<i class="fas fa-calendar-alt" aria-hidden="true"></i>
                    </button>
                </span>
            </p>            
            <!-- Bootstrap impl -->
			<select *ngSwitchCase="'LIST_MULTI'"
			    [attr.id]="'control_field_' + field.name" 
			    class="form-control"
			    style="height:150px"
			    [attr.width]="'100%'" 
			    [attr.placeholder]="field.placeholder || 'Select option(s)'"  
			    [attr.title]="field.tooltip" 
			    multiple			     
			    [(ngModel)]="field.content"
			    (change)="updateFn(field)">
			    <option *ngFor="let option of field.filteredOptions" [value]="option">
			        {{ option.name }}
			    </option>
			</select>			
			<!-- @ng-select impl -->
			<!-- 
			<ng-select *ngSwitchCase="'LIST_MULTI'" 
			    [id]="'control_field_' + field.name" 
			    (change)="updateFn(field)"
			    [attr.width]="'100%'" 
			    class="form-control" 
			    style="height:150px"	
			    [(ngModel)]="field.content"		    
				[items]="field.filteredOptions"
			    bindLabel="name"
			    bindValue="value"
			    [multiple]="true"
			    [placeholder]="field.placeholder || 'Select option(s)'" 
			    [title]="field.tooltip"
			    [clearable]="true"
			    [searchable]="true">
			</ng-select>
			 -->			
			
			<!-- // Original -->
			<!-- 
            <select id="control_field_{{field.name}}" (change)='updateFn(field)' width="'100%'" data-placeholder-text-single="'{{field.placeholder || 'Select your Option'}}'" title='{{field.tooltip}}' chosen allow-single-deselect="true" style='height:150px' class='form-control' *ngSwitchCase="list" data-ng-model="field.content" ng-options="c.name for c in field.availableOptions">
            </select>
             -->
            <!-- Bootstrap impl -->
			<select *ngSwitchCase="'LIST'"
			    [attr.id]="'control_field_' + field.name" 
			    class="form-control"
			    [attr.width]="'100%'" 
			    [attr.placeholder]="field.placeholder || 'Select an option'" 
			    [attr.title]="field.tooltip" 			     
			    [(ngModel)]="field.content"
			    (change)="updateFn(field)">
			    <option *ngFor="let option of field.filteredOptions" [value]="option.value">
			        {{ option.name }}
			    </option>
			</select>			
			<!-- @ng-select impl -->
			<!-- 
			<ng-select *ngSwitchCase="'LIST'" 
			    [id]="'control_field_' + field.name" 
			    (change)="updateFn(field)"
			    [attr.width]="'100%'" 
			    class="form-control" 
			    [(ngModel)]="field.content"
				[items]="field.filteredOptions"
			    bindLabel="name"
			    bindValue="value"
			    [multiple]="false"
			    [placeholder]="field.placeholder || 'Select an option'" 
			    [title]="field.tooltip"
			    [clearable]="true"
			    [searchable]="true">
			</ng-select>
			 -->
			 
            <input 
            	type="checkbox" 
            	*ngSwitchCase="'boolean'" 
            	[(ngModel)]="field.content" 
            	[attr.id]="'control_field_'+field.name" 
            	[attr.title]='field.tooltip' />
            
            <div *ngSwitchCase="'STRING'">
                <div class="flex" [ngClass]="{'stringInputPad' : i > 0, 'input-group' : i > 0}" *ngFor="let listItem of field.list; let i = index;">
            		<!-- // Suggest implementation -->
					<!-- // Old
                    <input *ngIf="field.suggest" 
                    	class="form-control flex-19" 
                    	uib-(keyup.enter)="term for term in getSuggestions(field.name, $viewValue)" 
                    	typeahead-min-length="2" 
                    	type="text" 
                    	placeholder='{{field.placeholder}}' 
                    	title='{{field.tooltip}}' 
                    	[(ngModel)]="listItem.content" 
                    	(keyup.enter)="updateSearch()" 
                    	[attr.aria-label]="'control_field_' + field.name + '_' + i" />
                    -->
                    <input *ngIf="field.suggest" 
                    	class="form-control flex-19 suggestion-container" 
                    	[ngbTypeahead]="search"
                    	type="text" 
                    	placeholder='{{field.placeholder}}' 
                    	[attr.title]='field.tooltip' 
                    	[(ngModel)]="listItem.content" 
                    	[attr.id]="'control_field_' + field.name + '_' + i"
                    	(keyup.enter)="updateSearch()" 
                    	[attr.aria-label]="'control_field_' + field.name + '_' + i" />								
							                    	
                    <input *ngIf="!field.suggest" 
                    	class="form-control flex-19" 
                    	type="text" 
                    	placeholder='{{field.placeholder}}' 
                    	[attr.title]='field.tooltip' 
                    	[(ngModel)]="listItem.content" 
                    	[attr.id]="'control_field_' + field.name + '_' + i"
                    	(keyup.enter)="updateSearch()" 
                    	[attr.aria-label]="'control_field_' + field.name + '_' + i" />
                    <button *ngIf="listItem?.content?.length>0" 
                    	type="button" 
                    	class="btn btn-default clear-search" 
                    	(click)="clearSearch(i)"
                    	aria-label="Clear">
                    		<i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
            
            <!-- Treat all other field types as a simple STRING -->
            <div *ngSwitchDefault>
                <div class="flex">
                    <input class="form-control flex-19" 
                    	type="text" 
                    	placeholder='{{field.placeholder}}' 
                    	[attr.title]='field.tooltip' 
                    	[(ngModel)]="field.content" 
                    	[attr.id]="'control_field_' + field.name"
                    	(keyup.enter)="updateSearch()" 
                    	[attr.aria-label]="'control_field_' + field.name" />
                    <button *ngIf="field?.content?.length>0"
                    	 type="button" 
                    	 class="btn btn-default clear-search" 
                    	 (click)="clearSearch(-1)"
                    	 aria-label="Clear">
                    		<i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
            
            <span id="inlineHelp_{{field.name}}" class="help-inline"></span>
        </div>
    </div>
</div>
